<template>
    <b-row>
        <b-col cols="12">
            <ContentOrLoading>
                <b-row v-if="!loading">                
                    <b-col cols="3" class="my-3" v-for="(imagen, index) in imagenes.data" :key="index">
                        <b-container fluid class="bg-light p-3">
                            <b-row>
                                <b-col cols="12" class="mb-3">
                                    <b-button size="sm" class="float-right p-1 bg-danger" @click="$modal.show('borrar-imagen-' + imagen.id)">
                                        <b-icon icon="trash"/>
                                    </b-button>
                                    <BorrarModalComponent
                                        :name="'borrar-imagen-' + imagen.id"
                                        :title="'Borrar Imagen ' + imagen.nombre"
                                        :borrarTitle="'¿Está seguro que desea borrar la imagen ' + imagen.nombre + ' ?'"
                                        :confirmButton="'SI, BORRAR'"
                                        @close="() => $modal.hide('borrar-imagen-' + imagen.id)"
                                        @confirm="() => borrarImagen(imagen.id)"
                                    />
                                </b-col>
                                <b-col cols="12">
                                    <b-img 
                                        :src="imagen.url"
                                        fluid
                                    />
                                </b-col>
                                <b-col cols="12">
                                    <hr/>
                                    <p class="text-center">{{ imagen.nombre }}</p>
                                </b-col>
                            </b-row>                        
                        </b-container>                    
                    </b-col>
                </b-row>
            </ContentOrLoading>
        </b-col>
        <b-col cols="12">
            <b-pagination
                align="center"
                v-if="imagenes.meta"
                v-model="imagenes.meta.current_page"
                :total-rows="imagenes.meta.total"
                :per-page="imagenes.meta.per_page"
                @page-click="pageClicked"
            />
        </b-col>
    </b-row>
</template>

<script>
    import apiService from "@/services/api-comunicados";
    import BorrarModalComponent from "@/components/backend/components/BorrarModalComponent";

    export default {
        name: "ListadoImagenes",
        props: {
            carpeta_id: {
                type: [String, Number],
                required: false
            },
            search:{
                type: String,
                default: ""
            }
        },
        data() {
            return {
                imagenes: {
                    data: [],
                    meta: { current_page: 1, per_page: 12 }
                },
                loading: false
            }
        },
        mounted() {
            this.getImagenes();
        },
        methods: {
            async getImagenes(page = 1) {
                try {
                    this.loading = true;
                    const filters = {
                        search: this.search,
                        carpeta_id: this.carpeta_id,
                        per_page: 12,
                        page: page
                    }

                    const response = await apiService.getImagenesMedios(filters);
                    this.imagenes = response;
                } catch (error) {
                    console.error("Error al obtener las imágenes", error);
                } finally {
                    this.loading = false
                }
            },
            async borrarImagen(imagen_id) {
                try {
                    this.loading = true;
                    const response = await apiService.borrarImagen(imagen_id);
                    this.getImagenes();
                } catch (error) {
                    console.error("Error al borrar la imagen", error);
                } finally {
                    this.$modal.hide('borrar-imagen-' + imagen_id);
                    this.loading = false
                }
            },
            pageClicked(event, page) {
                this.getImagenes(page);
            }
        },
        watch: {
            carpeta_id(newVal, oldVal) {
                if (newVal !== oldVal) {
                    this.getImagenes();
                }
            },

            search(newVal, oldVal) {
                if (newVal !== oldVal) {
                    this.getImagenes();
                }
            }
        },
        components: {
            BorrarModalComponent
        }
    };
</script>